
















































import { Component, Vue } from 'vue-property-decorator';
import Car from '@/entities/Car';
import CarService from '@/services/car';
import TimeLeft from '@/components/TimeLeft.vue';

@Component({
    components: { TimeLeft },
})
export default class Cars extends Vue {
    carService = new CarService();

    carsList: Car[] = null;

    get cars(): Car[] {
        if (!this.carsList) {
            this.setCarsList();
        }

        return this.carsList || [];
    }

    setCarsList() {
        this.carService.listAll().then((cars) => {
            this.carsList = cars;
        });
    }
}
